/* eslint-disable no-unused-vars */
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Alert, IconButton, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { routes } from 'const';

export default function CardOnFileNotification() {
  const [open, setOpen] = React.useState(true);
  const history = useHistory();
  const { t } = useTranslation('labels');

  return (
    <Box sx={{ width: '100%' }} id="cardNotificationBox">
      <Collapse in={open}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2, cursor: 'pointer' }}
          severity="warning"
          variant="filled"
          icon={false}
          onClick={() => history.push(routes.payment)}
        >
          {t('click_here_to_setup_your_payment_method_in_settings')}
        </Alert>
      </Collapse>
    </Box>
  );
}
